import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const AICallout = () => {
  return (
    <section className="py-32 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center opacity-20 mix-blend-screen"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/80 to-purple-900/20"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-3xl">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-purple-500/40 bg-purple-500/10 text-purple-300 text-sm font-bold tracking-widest uppercase mb-8 backdrop-blur-md font-display">
              <SafeIcon icon="FiCpu" className="animate-pulse" />
              After Hours CallBot
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-8 leading-tight text-white">
              Your Next Customer May Call <span className="text-gradient-alt">After You Close.</span>
            </h2>
            
            <div className="text-lg text-gray-300 mb-10 space-y-6 font-light leading-relaxed">
              <p>
                After Hours CallBot helps businesses answer incoming calls, capture opportunities, qualify leads, and support customers when the regular team is unavailable.
              </p>
              <p>
                Instead of sending every after-hours caller to voicemail, businesses can provide an immediate, helpful response and collect the information their team needs to take the next step.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6">
              <a href="https://afterhourscallbot.com" target="_blank" rel="noopener noreferrer" className="btn-neon !bg-[linear-gradient(90deg,#9333ea,#ec4899)]">
                Visit AfterHoursCallBot.com
              </a>
              <Link to="/" state={{ scrollTo: 'contact' }} className="btn-hollow">
                Request Demo
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AICallout;